import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN Heading variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const headingVariants = cva('font-heading font-heading-weight', {
  variants: {
    variant: {
      h1: 'text-h1 leading-h1 [--font-family-heading-level:var(--font-family-h1)]',
      h2: 'text-h2 leading-h2 [--font-family-heading-level:var(--font-family-h2)]',
      h3: 'text-h3 leading-h3 [--font-family-heading-level:var(--font-family-h3)]',
      h4: 'text-h4 leading-h4 [--font-family-heading-level:var(--font-family-h4)]',
      h5: 'text-h5 leading-h5 [--font-family-heading-level:var(--font-family-h5)]',
      h6: 'text-h6 leading-h6 [--font-family-heading-level:var(--font-family-h6)]',
    },
    color: {
      default: 'text-heading',
      white: 'text-white',
      subtext: 'text-subtext',
      primary: 'text-primary-700',
      secondary: 'text-secondary-700',
      'category-1': 'text-data-category-1',
      'category-2': 'text-data-category-2',
      'category-3': 'text-data-category-3',
    },
    align: {
      left: 'text-left',
      center: 'text-center',
      right: 'text-right',
    },
  },
  defaultVariants: {
    variant: 'h1',
    color: 'default',
  },
});

export type HeadingVariantProps = VariantProps<typeof headingVariants>;
